import chroma from './src/index';
export = chroma;
